<template>
  <button
    :disabled="loading || disabled"
    v-bind="$attrs"
    class="button"
    :class="{
      primary,
      secondary,
      outlined,
      full,
      small,
      danger
    }"
    v-on="$listeners"
  >
    <template v-if="!loading">
      <slot />
    </template>
    <template v-else>
      <div class="h-5">
        <i class="fas fa-spinner fa-spin" />
      </div>
    </template>
  </button>
</template>

<script>
export default {
  name: 'ALButton',
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  // margin-inline-end: 16px;

  @apply
    transition-colors
    text-muted-950
    dark:text-muted-200
    border
    border-solid
    border-muted-300
    bg-muted-100
    hover:bg-muted-300
    dark:hover:bg-muted-600
    dark:border-muted-600
    dark:bg-muted-700
    rounded
    text-sm
    px-3
    2xl:px-5
    py-2.5
    mb-2
    h-auto
    cursor-pointer
  ;

  &.full {
    @apply w-full
  }

  &.small {
    @apply
      px-3
      py-1
      text-sm
  }

  &.primary {
    @apply
      bg-primary-500
      hover:bg-primary-700
      dark:hover:bg-primary-700
      text-white;

    &.outlined,
    &.is-outlined {
      @apply
        bg-primary-900
        text-primary-200;
    }
  }

  &.outlined,
  &.is-outlined {
    @apply
      text-muted-900
      border
      border-solid
      bg-transparent
      dark:text-muted-50
      dark:border-muted-500;
  }

  &.secondary {
    @apply
      h-10
      bg-white
      rounded
      flex
      items-center
      border
      border-solid
      justify-center
      dark:text-white
      dark:bg-muted-700
      dark:border-muted-600
      hover:border-muted-400
      dark:hover:bg-muted-700
      dark:hover:border-muted-700
      border-muted-300
      text-muted-900
      dark:hover:text-white
      text-sm;
  }

  &.danger {
    @apply
      bg-red-500
      hover:bg-red-700
      dark:hover:bg-red-700
      text-white;

    &.outlined,
    &.is-outlined {
      @apply
        bg-transparent
        border-red-500
        text-red-200;
    }
  }
}
</style>
